/**
 * 用户交互模块
 * 处理命令行交互和用户确认
 */
import * as readline from 'readline';

/**
 * 提示用户选择是否继续
 * @param question - 提示问题
 * @returns Promise<boolean> - 用户选择（true 表示继续，false 表示取消）
 */
export const promptUser = (question: string): Promise<boolean> => {
  const rl = readline.createInterface({
    input: process.stdin,
    output: process.stdout,
  });

  return new Promise((resolve) => {
    rl.question(question, (answer) => {
      rl.close();
      resolve(answer.toLowerCase() === 'y');
    });
  });
};

